import React, { Component } from 'react'
import _ from 'lodash'
export default class Books extends Component {
  constructor(props) {
    super(props)
  }
  _renderBooks = bookData => {}
  render() {
    const { books } = this.props
    if (_.isEmpty(books)) {
      return (
        <div className="books-wrapper">
          <h2>
            {this.props.title}
            <span className="title-end">_</span>
          </h2>
          no books at the moment
        </div>
      )
    }
    return (
      <div className="books-wrapper">
        <h2>
          {this.props.title}
          <span className="title-end">_</span>
        </h2>
        <div className="item">
          {Object.keys(books).map(function(key) {
            return (
              <div className="book-item" key={key}>
                <div className="book-cover">
                  <img src={books[key].cover} alt="cover" />
                </div>
                <div className="book-data">
                  <div className="book-title">{books[key].title}</div>
                  <div className="book-author">{books[key].author}</div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Books/Books.jsx